const work_surprise = `Hey Olga,
I just had to tell you about the surprise I had at my new job induction today! 
Can you believe they organized a little welcome party for me? 
I was completely surprised, to be honest. 
I had no idea they would go to such lengths to make me feel welcome.
It was a really heartwarming gesture, and it made me feel so appreciated. 
Everyone was so friendly and supportive, and it definitely helped ease my nerves about starting at a new place. 
I'm already feeling more excited and confident about this job.
I'm planning to get to know my colleagues better and make the most of this opportunity. 
It seems like a great team, and I can't wait to see what's in store for me here. 
I'll keep you posted on how things go!
Take care`;

export default work_surprise;